import React, { useState } from 'react';
import { Stethoscope, Users } from 'lucide-react';
import ManageTherapists, { CLINICAL_ROLES } from './ManageTherapists';

// Both tabs are the same interface with a different role list. The Therapists
// tab is the view that existed before the 'wmf' role, unchanged and filtered to
// the clinical roles; the Users tab is every account, and the only place a
// metrics-only user can be created.
const ALL_ROLES = [...CLINICAL_ROLES, 'wmf'];

const TABS = [
  {
    key: 'therapists',
    label: 'Therapists',
    icon: Stethoscope,
    props: {
      title: 'Manage Therapists',
      description: 'Add, edit, or manage therapist accounts',
      addLabel: 'Add Therapist',
      entityLabel: 'Therapist',
      roles: CLINICAL_ROLES,
      visibleRoles: CLINICAL_ROLES,
    },
  },
  {
    key: 'users',
    label: 'Users',
    icon: Users,
    props: {
      title: 'Manage Users',
      description:
        'Every platform account, including WMF staff who view program metrics only',
      addLabel: 'Add User',
      entityLabel: 'User',
      roles: ALL_ROLES,
      visibleRoles: ALL_ROLES,
    },
  },
];

const ManageUsers = () => {
  const [active, setActive] = useState('therapists');
  const tab = TABS.find((candidate) => candidate.key === active);

  return (
    <div className="space-y-6">
      <div>
        <h1 className="text-xl font-semibold text-slate-900">Manage Users</h1>
        <p className="mt-1 text-sm text-slate-500">
          Accounts and roles. A role decides what a user can reach, so changing
          one takes effect the next time that user signs in.
        </p>
      </div>

      <div className="border-b border-slate-200">
        <nav className="-mb-px flex gap-6" aria-label="User types">
          {TABS.map(({ key, label, icon: Icon }) => (
            <button
              key={key}
              type="button"
              onClick={() => setActive(key)}
              aria-current={key === active ? 'page' : undefined}
              className={`flex items-center gap-2 border-b-2 px-1 pb-3 text-sm font-medium ${
                key === active
                  ? 'border-blue-600 text-blue-600'
                  : 'border-transparent text-slate-500 hover:border-slate-300 hover:text-slate-700'
              }`}
            >
              <Icon className="h-4 w-4" />
              {label}
            </button>
          ))}
        </nav>
      </div>

      {/* Keyed so switching tabs resets the table and modal state rather than
          carrying a selected therapist across into a different role list. */}
      <ManageTherapists key={tab.key} {...tab.props} />
    </div>
  );
};

export default ManageUsers;
